import React, { FC } from 'react';
import myImage from "./logo-light.svg";


interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width = 2155, height = 854 }) => {
	return (
		<img width={height !== 854 && !!height ? height * (2155 / 550) : width} src={myImage} />
	);
};

export default Logo;
